
import { i18nText } from '@/locales';
import {RouterNameEnum} from '@/router/router.types';
import {RouterProperties} from '@/router/routerProperties';

export const ClientRoutes = [
    {
        path: '/clients',
        redirect: '/clients/index',
        component: (): any => import('@/UI/layouts/MainLayout.vue'),
        meta: {
            alias: RouterNameEnum.Clients,
            auth: true,
        },
        children: [
            {
                path: '/clients/index/:Studio',
                meta: {
                    alias: RouterNameEnum.Clients,
                    title: i18nText("Клиенты - EPILIER"),
                    breadcrumb: [
                        {name: i18nText("Клиенты"), support: ['studioselect']}
                    ],
                    props: {
                        source: {
                            root: "clients",
                            name: "clients",
                            items: "clients",
                            item: "client",
                            routePage: RouterNameEnum.ClientsPage,
                        },
                    },
                },
                props: {
                    source: {
                        root: "clients",
                        name: "clients",
                        items: "clients",
                        item: "client",
                        routePage: RouterNameEnum.ClientsPage,
                    },
                },
                name: RouterNameEnum.Clients,
                component: (): any => import('@/UI/pages/clients/pages/Clients.vue'),
                children: [
                    {
                        path: 'page/:page/:total/:filter/:sorted',
                        meta: {
                            alias: RouterNameEnum.Clients,
                            title: i18nText("Клиенты - EPILIER"),
                            breadcrumb: [
                                {name: i18nText("Клиенты"), support: ['studioselect']},
                            ],
                            props: {
                                source: {
                                    root: "clients",
                                    name: "clients",
                                    items: "clients",
                                    item: "client",
                                    routePage: RouterNameEnum.ClientsPage,
                                },
                            },
                        },
                        props: {
                            source: {
                                root: "clients",
                                name: "clients",
                                items: "clients",
                                item: "client",
                                routePage: RouterNameEnum.ClientsPage,
                            },
                        },
                        name: RouterNameEnum.ClientsPage,
                        component: (): any => import('@/UI/pages/clients/pages/Clients.vue'),
                    },
                ]
            },
            {
                path: 'accounts',
                name: RouterNameEnum.ClientsAccountsAll,
                component: (): any => import('@/UI/pages/clients/pages/Accounts.vue'),
                meta: {
                    alias: RouterNameEnum.ClientsAccountsAll,
                    title: i18nText("Счета - Клиентов"),
                    breadcrumb: [{name: i18nText("Счета")}],
                    props: {
                        source: {
                            root: "clientsAccountsAll",
                            name: "clientsAccountsAll",
                            items: "items",
                            item: "item",
                            routePage: RouterNameEnum.ClientsAccountsAllPage,
                        },
                    },
                },
                //props: { source: RouterProperties.clientsaccountsAll },
            },
            {
                path: 'accounts/page/:page/:total/:filter/:sorted',
                name: RouterNameEnum.ClientsAccountsAllPage,
                component: (): any => import('@/UI/pages/clients/pages/Accounts.vue'),
                meta: {
                    alias: RouterNameEnum.ClientsAccountsAll,
                    title: i18nText("Счета - Клиентов"),
                    breadcrumb: [{name: i18nText("Счета")}],
                    props: {
                        source: {
                            root: "clientsAccountsAll",
                            name: "clientsAccountsAll",
                            items: "items",
                            item: "item",
                            routePage: RouterNameEnum.ClientsAccountsAllPage,
                        },
                    },
                },
            },

            {
                path: '/clients/create/:Studio',
                meta: {
                    alias: RouterNameEnum.Clients,
                    title: i18nText("Клиенты | Создание - EPILIER"),
                    breadcrumb: [{name: i18nText("Клиенты"), link: RouterNameEnum.Clients}, {name: i18nText("Создание клиента")}],
                },
                name: RouterNameEnum.clientCreate,
                component: (): any => import('@/UI/pages/clients/pages/Create.vue'),
            },

            {
                path: '/clients/creation',
                meta: {
                    alias: RouterNameEnum.Clients,
                    title: i18nText("Клиенты | Создание - EPILIER"),
                    breadcrumb: [
                        {name: i18nText("Клиенты"), link: 'Clients'},
                        {name: i18nText("Создание")}
                    ],
                },
                name: RouterNameEnum.ClientCreation,
                component: (): any => import('@/UI/pages/clients/pages/Create.vue'),
            },
            {
                path: '/clients/:id',
                redirect: '/clients/:id/general',
                name: RouterNameEnum.ClientDetail,
                meta: {
                    alias: RouterNameEnum.Clients,
                    title: '',
                    breadcrumb: [
                        {name: i18nText("Клиенты"), link: RouterNameEnum.Clients},
                        {name: i18nText("Детальная")}
                    ],
                },
                component: (): any => import('@/UI/pages/clients/pages/Detail.vue'),
                children: [
                    {
                        path: 'general',
                        name: RouterNameEnum.ClientDetailCommon,
                        meta: {
                            alias: RouterNameEnum.Clients,
                            title: '',
                            breadcrumb: [
                                {name: i18nText("Клиенты"), link: RouterNameEnum.Clients},
                                {name: i18nText("Детальная")}
                            ],
                        },
                        component: (): any => import('@/UI/components/clients/ClientGeneral.vue'),
                    },
                    {
                        path: 'history/page/:page/:total/:filter/:sorted',
                        name: RouterNameEnum.ClientDetailHistoryPage,
                        component: (): any => import('@/UI/components/clients/ClientsHistory.vue'),
                        meta: {
                            alias: RouterNameEnum.Clients,
                            title: '',
                            breadcrumb: [
                                {name: i18nText("Клиенты"), link: RouterNameEnum.Clients},
                                {name: i18nText("История посещений")}
                            ],
                            props: {
                                source: {
                                    root: "visits",
                                    name: "visits",
                                    items: "visits",
                                    item: "visit",
                                    routePage: RouterNameEnum.ClientDetailHistoryPage,
                                },
                            },
                        },
                    },
                    {
                        path: 'notes/page/:page/:total/:filter/:sorted',
                        name: RouterNameEnum.ClientDetailNotesPage,
                        component: (): any => import('@/UI/components/clients/ClientNotes.vue'),
                        meta: {
                            alias: RouterNameEnum.Clients,
                            title: '',
                            breadcrumb: [
                                {name: i18nText("Клиенты"), link: RouterNameEnum.Clients},
                                {name: i18nText("Записи")}
                            ],
                            props: {
                                source: {
                                    root: "visits",
                                    name: "visits",
                                    items: "visits",
                                    item: "visit",
                                    routePage: RouterNameEnum.ClientDetailNotesPage,
                                },
                            },
                        },
                    },
                    {
                        path: 'tasks/page/:page/:total/:filter',
                        name: RouterNameEnum.ClientDetailTasksPage,
                        component: (): any => import('@/UI/components/clients/ClientTasks.vue'),
                        meta: {
                            alias: RouterNameEnum.Clients,
                            title: '',
                            breadcrumb: [
                                {name: i18nText("Клиенты"), link: RouterNameEnum.Clients},
                                {name: i18nText("Задачи")}
                            ],
                            props: {
                                source: {
                                    root: "?",
                                    name: "?",
                                    items: "?",
                                    item: "?",
                                    routePage: RouterNameEnum.ClientDetailTasksPage,
                                },
                            },
                        },
                    },
                    {
                        // props: { source: RouterProperties.clientDocuments },
                        path: 'documents/page/:page/:total/:filter',
                        name: RouterNameEnum.ClientDetailDocumentsPage,
                        component: (): any => import('@/UI/components/clients/ClientDocuments.vue'),
                        meta: {
                            alias: RouterNameEnum.Clients,
                            title: '',
                            breadcrumb: [
                                {name: i18nText("Клиенты"), link: RouterNameEnum.Clients},
                                {name: i18nText("Документы")}
                            ],
                            props: {
                                source: {
                                    root: "?",
                                    name: "?",
                                    items: "?",
                                    item: "?",
                                    routePage: RouterNameEnum.ClientDetailDocumentsPage,
                                },
                            },
                        },
                    },
                    {
                        path: 'photo/page/:page/:total/:filter',
                        name: RouterNameEnum.ClientDetailPhotoPage,
                        component: (): any => import('@/UI/components/clients/ClientPhoto.vue'),
                        meta: {
                            alias: RouterNameEnum.Clients,
                            title: '',
                            breadcrumb: [
                                {name: i18nText("Клиенты"), link: RouterNameEnum.Clients},
                                {name: i18nText("Фотографии")}
                            ],
                            props: {
                                source: {
                                    root: "?",
                                    name: "?",
                                    items: "?",
                                    item: "?",
                                    routePage: RouterNameEnum.ClientDetailPhotoPage,
                                },
                            },
                        },
                    },
                    {
                        path: 'contraindications/page/:page/:total/:filter',
                        name: RouterNameEnum.ClientDetailContraindicationsPage,
                        component: (): any => import('@/UI/components/clients/ClientContraindications.vue'),
                        meta: {
                            alias: RouterNameEnum.Clients,
                            title: '',
                            breadcrumb: [
                                {name: i18nText("Клиенты"), link: RouterNameEnum.Clients},
                                {name: i18nText("Противопоказания")}
                            ],
                            props: {
                                source: {
                                    root: "?",
                                    name: "?",
                                    items: "?",
                                    item: "?",
                                    routePage: RouterNameEnum.ClientDetailContraindicationsPage,
                                },
                            },
                        },
                    },
                    /* {
                        path: 'loyalty/page/:page/:total/:filter',
                        name: RouterNameEnum.ClientDetailLoyaltyPage,
                        component: (): any => import('@/UI/components/clients/ClientLoyalty.vue'),
                        meta: {
                            alias: RouterNameEnum.Clients,
                            title: '',
                            breadcrumb: [
                                {name: 'Клиенты', link: RouterNameEnum.Clients},
                                {name: 'Лояльность'}
                            ],
                            props: {
                                source: {
                                    root: "?",
                                    name: "?",
                                    items: "?",
                                    item: "?",
                                    routePage: RouterNameEnum.ClientDetailLoyaltyPage,
                                },
                            },
                        },
                    }, */
                    {
                        path: 'loyalty',
                        name: RouterNameEnum.ClientDetailLoyaltyIndex,
                        component: (): any => import('@/UI/components/clients/loyalty/Tabs.vue'),
                        meta: {
                            alias: RouterNameEnum.ClientDetailLoyaltyPage,
                        },
                        children: [
                            {
                                path: "subscriptions/:page/:total",
                                meta: {
                                    alias: RouterNameEnum.ClientDetailLoyaltyPage,
                                    title: i18nText("Лояльность | Типы сертификатов - EPILIER"),
                                    breadcrumb: [
                                        { name: i18nText("Абонементы"), support: ["studioselect"] }
                                    ],
                                    props: {
                                        source: {
                                            root: "loyaltySubscription",
                                            name: "loyaltySubscription",
                                            items: "loyaltySubscriptions",
                                            item: "loyaltySubscription",
        
                                            routePage: RouterNameEnum.ClientDetailLoyaltyPage,
                                        },
                                    },
                                },
                                props: { source: RouterProperties.ClientDetailLoyaltyPage },
                                name: RouterNameEnum.ClientDetailLoyaltyPage,
                                component: (): any => import("@/UI/components/clients/loyalty/Subscriptions.vue"),
                            },
                            {
                                path: "certificates/:page/:total",
                                meta: {
                                    alias: RouterNameEnum.ClientDetailLoyaltyPage,
                                    title: i18nText("Лояльность | Сертификаты - EPILIER"),
                                    breadcrumb: [
                                        { name: i18nText("Сертификаты"), support: ["studioselect"] },
                                    ],
                                    props: {
                                        source: {
                                            root: "loyaltyCert",
                                            name: "loyaltyCert",
                                            items: "loyaltyCerts",
                                            item: "loyaltyCert",

                                            routePage: RouterNameEnum.clientsDetailLoyaltyCertificates,
                                        },
                                    },
                                },
                                name: RouterNameEnum.clientsDetailLoyaltyCertificates,
                                props: { source: RouterProperties.clientsDetailLoyaltyCertificates },
                                component: (): any => import("@/UI/components/clients/loyalty/Certificates.vue"),
                            },
                        ],
                    },
                    {
                        path: 'account/page/:page/:total/:filter/:sorted',
                        name: "ClientDetailAccountsPage",
                        component: (): any => import('@/UI/components/clients/ClientAccount.vue'),
                        meta: {
                            alias: RouterNameEnum.Clients,
                            title: '',
                            breadcrumb: [
                                {name: i18nText("Клиенты"), link: RouterNameEnum.Clients},
                                {name: i18nText("Счета")}
                            ],
                            props: {
                                source: {
                                    root: "clientsAccountsHistory",
                                    name: "clientsAccountsHistory",
                                    items: "items",
                                    item: "item",
                                    routePage: "ClientDetailAccountsPage",
                                },
                            },
                        },
                    },
                ],
            },
        ],
    },
];
